import React, { useRef, useState, useCallback, useMemo } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { ToastContainer } from "react-toastify";
import AdminAppBar from "../../adminComponents/AdminAppBar";
import { useLocation, useNavigate } from "react-router-dom";
import marketingHubService from "../../Services/MarketingHubService";
import { showErrorToast } from "../../Constant/Notification";
import Loader from "../../Constant/Loader";
import BackArrows from "../../Form/BackArrow/BackArrows";
import { getIcons } from "../../Constant/Constant";

const CreateTextAndImageTemplate = () => {
  const editor = useRef(null);
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [subject, setSubject] = useState("");
  const userObj = JSON.parse(localStorage.getItem("userData"));
  const userRole = userObj?.user?.role;
  const userId = userObj?.user?.uid;
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const { groupId } = location.state || {};
  const navigate = useNavigate();

  const icons = getIcons();

  const handleBack = () => {
    navigate(-1);
  };

  const handleAddTemplate = async () => {
    if (!title || !content || !subject) {
      showErrorToast("All fields are required. Please fill all the field.");
      return;
    }
    const templateData = {
      title,
      content,
      subject,
      group: groupId,
      createdBy: userId,
      modifiedBy: userId,
    };

    try {
      const response = await marketingHubService.createTextAndImageTemplate(
        templateData
      );
      if (response.status === 200) {
        navigate(-1, { state: { message: "Template created succussfully" } });
        setTitle("");
        setContent("");
        setSubject("");
      }
    } catch (error) {
      console.log(error.message);
      showErrorToast(
        error.message || "An error occurred while adding the template."
      );
    }
  };

  const toolbarOptions = useMemo(
    () => [
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      ["bold", "italic", "underline", "strike"],
      ["link", "image"],
      [{ list: "ordered" }, { list: "bullet" }],
      [{ color: [] }, { background: [] }],
      [{ align: [] }],
      ["clean"],
    ],
    []
  );

  const handleImageUpload = async (file) => {
    const formData = new FormData();
    formData.append("file", file);
    setLoading(true);
    try {
      const response = await marketingHubService.createImageTemplate(formData);
      if (response.status === 200) {
        return response.data.imageUrl;
      }
    } catch (error) {
      showErrorToast("Image upload failed. Please try again.");
      console.error(error);
    } finally {
      setLoading(false); // Stop loader
    }
  };

  const imageHandler = useCallback(() => {
    const input = document.createElement("input");
    input.setAttribute("type", "file");
    input.setAttribute("accept", "image/png, image/jpeg");
    input.click();

    input.onchange = async () => {
      const file = input.files[0];
      if (file) {
        const imageUrl = await handleImageUpload(file);
        if (imageUrl) {
          const quill = editor.current.getEditor();
          const range = quill.getSelection();
          quill.insertEmbed(range.index, "image", imageUrl);
        }
      }
    };
  }, []);

  const module = useMemo(
    () => ({
      toolbar: {
        container: toolbarOptions,
        handlers: {
          image: imageHandler,
        },
      },
    }),
    [toolbarOptions, imageHandler]
  );

  return (
    <div className="bg-appGrayBackground pb-10 pt-14">
      {loading && <Loader />}
       <AdminAppBar />
      <ToastContainer />
      <div className="mt-14 px-20 xl:px-6 relative flex justify-between gap-5">
        <div className="flex gap-6">
          <BackArrows onClick={handleBack} />
          <div>
            <h1 className="text-4xl font-semibold whitespace-nowrap">
              New Text & Image Template
            </h1>
          </div>
        </div>
        <div>
          <button
            onClick={handleAddTemplate}
            className="border-2 whitespace-nowrap bg-customGreen rounded-md font-semibold p-1 px-5 w-fit text-lg text-white h-10 text-center"
          >
            Add Template
          </button>
        </div>
      </div>

      <div className=" mx-20 mt-5 bg-white rounded-lg shadow-md">
        <div className="flex   flex-col gap-10 px-20 py-12 ">
          <div className="flex  gap-5 items-center">
            <div className="">
              <h2 className="text-3xl font-medium text-gray-900">
                Template Name :
              </h2>
            </div>
            <div>
              <h2 className="text-2xl font-bold text-gray-900">
                Template Name
              </h2>
            </div>
          </div>
          <div className="flex  gap-5 items-center">
            <div className="w-[30%]">
              <h2 className="text-3xl font-medium text-nowrap text-gray-900">
                Temp Title{" "}
              </h2>
            </div>

            <input
              type="text"
              placeholder="Temp Title"
              className="px-3 border-2 bg-stone-100 forced-colors:ring-transparent border-stone-200 rounded-xl w-full h-10"
            />
          </div>
        </div>
      </div>

      {/* {"Email Template"} */}

      <div className=" mx-20 my-10 font-medium text-[32px]">Email Template</div>

      <div className="mx-20 mt-5 bg-white rounded-lg shadow-md">
        <div className="flex flex-col gap-10 px-20 pt-2 pb-12">
          <div className="flex gap-5 items-center">
            <div className="w-1/3">
              <h2 className="text-3xl font-medium text-gray-900 whitespace-nowrap">
                Subject/Heading
              </h2>
            </div>
            <div className="flex flex-col w-full mt-10">
              <input
                type="text"
                placeholder="Temp Title"
                className="px-3 border-2 bg-stone-100 border-stone-200 rounded-xl w-full h-10"
              />
              <p className="text-sm mt-3">
                * Note: The subject will be used as the heading in SMS and
                WhatsApp.
              </p>
            </div>
          </div>

          <div className="flex gap-5 items-start">
            <div className="w-1/3">
              <label className="text-3xl font-medium text-gray-900 w-1/4">
                Main Content
              </label>
            </div>
            <div className="w-full">
              <ReactQuill
                ref={editor}
                value={content}
                modules={module}
                onChange={setContent}
                theme="snow"
                placeholder="Your Content"
                className="w-full h-60 pb-4 rounded-md "
              />
            </div>
          </div>
        </div>
      </div>

      {/* {"WhatsApp & SMS Template"} */}

      <div className=" mx-20 my-10 font-medium text-[32px]">
        WhatsApp & SMS Template
      </div>

      <div className="mx-20 mt-5 bg-white rounded-lg shadow-md">
        <div className="flex flex-col gap-10 px-20 pt-2 pb-12">
          <div className="flex gap-5 items-center">
            <div className="w-1/3">
              <h2 className="text-3xl font-medium text-gray-900 whitespace-nowrap">
                Subject/Heading
              </h2>
            </div>
            <div className="flex flex-col w-full mt-10">
              <input
                type="text"
                placeholder="Temp Title"
                className="px-3 border-2 bg-stone-100 border-stone-200 rounded-xl w-full h-10"
              />
              <p className="text-sm mt-3">
                * Note: The subject will be used as the heading in SMS and
                WhatsApp.
              </p>
            </div>
          </div>

          <div className="flex gap-5 items-center">
            <div className="w-1/3">
              <h2 className="text-3xl font-medium text-gray-900 whitespace-nowrap">
                Content ID
              </h2>
            </div>
            <div className="flex flex-col w-full mt-10">
              <input
                type="text"
                placeholder="Content ID"
                className="px-3 border-2 bg-stone-100 border-stone-200 rounded-xl w-full h-10"
              />
              <p className="text-sm mt-3">* Note only for sms</p>
            </div>
          </div>

          <div className="flex gap-5 items-start">
            <div className="w-1/3">
              <label className="text-3xl font-medium text-gray-900 w-1/4">
                Main Content
              </label>
            </div>
            <div className="w-full">
              <ReactQuill
                ref={editor}
                value={content}
                modules={module}
                onChange={setContent}
                theme="snow"
                placeholder="Your Content"
                className="w-full h-60 pb-4 rounded-md "
              />
            </div>
          </div>

          <div className="flex gap-5 items-center">
            <div className="w-1/3">
              <h2 className="text-3xl font-medium text-gray-900 whitespace-nowrap">
                Upload Image
              </h2>
            </div>
            <div className="flex flex-col w-full mt-10">
              <div className="relative w-full">
                <label className="flex items-center gap-2 px-3 border-2 bg-stone-100 border-stone-200 rounded-xl w-full h-10 cursor-pointer">
                  <img
                    src={icons?.uploadIcon}
                    className="w-5 h-5"
                    alt="Upload"
                  />
                  <span className="text-gray-600">Upload File</span>
                  <input
                    type="file"
                    className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                    //onChange={handleFileUpload}
                  />
                </label>
              </div>

              <p className="text-sm mt-3">
                * Note only 1 image can upload jpeg and png will be accepted
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* <div className="w-10/12 mx-20 mt-5">
        <div className="w-full px-10 py-5 bg-white shadow-md rounded-md">
          <form className="flex flex-col gap-5">
            <div className="flex items-center">
              <label
                className="w-1/4 text-gray-700 text-xl font-medium"
                htmlFor="title"
              >
                Template Title
              </label>
              <input
                className="shadow appearance-none bg-gray-100 border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="title"
                type="text"
                required
                value={title}
                onChange={(e) => setTitle(e.target.value)}
              />
            </div>

            <div className="flex items-center">
              <label
                className="w-1/4 text-gray-700 text-xl font-medium"
                htmlFor="subject"
              >
                Subject
              </label>
              <input
                className="shadow appearance-none bg-gray-100 border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="subject"
                type="text"
                required
                value={subject}
                onChange={(e) => setSubject(e.target.value)}
              />
            </div>

            <div className="text-center font-medium">
              Note: Subject will be used as heading in SMS and WhatsApp.
            </div>

            <div className="flex items-start gap-4">
              <label className="text-xl w-1/4 text-gray-700 font-medium">
                Main Content
              </label>

              <div className="w-full p-4 rounded-md relative">
                <ReactQuill
                  ref={editor}
                  value={content}
                  modules={module}
                  onChange={setContent}
                  theme="snow"
                  placeholder="Your Content"
                  className="w-full"
                />
              </div>
            </div>
          </form>
        </div>
      </div> */}
    </div>
  );
};

export default CreateTextAndImageTemplate;
